module.exports = __webpack_public_path__ + "17f9a5014038bb1ed4c2bb5839973cb5.svg";